var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.className},[_c('div',{staticClass:"container-hub__header"},[_vm._t("header")],2),_c('div',{staticClass:"container-hub__body"},[_vm._t("body")],2),_c('div',{staticClass:"container-hub__footer"},[_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }